// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();
  const error = location.state?.error;

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const handleSignIn = () => {
    // Derive redirect dynamically — never hardcode
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl,
    )}`;
  };

  return (
    <main className="min-h-screen bg-[#0F1F4E] text-[#F8F1D8] flex flex-col items-center justify-center px-6 grain">
      <div className="w-full max-w-md text-center" data-testid="login-page">
        <Link to="/" className="overline-gold inline-block mb-10">
          ← Back to site
        </Link>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] font-light mb-3">
          Studio <span className="italic text-[#EAD584]">admin</span>
        </h1>
        <p className="text-[#D6D6BD] text-sm leading-relaxed font-light mb-10">
          Sign in to manage bookings, blog posts, and the facials wait-list.
          Access is restricted to the studio owner.
        </p>
        {error && (
          <div
            data-testid="login-error"
            className="mb-6 text-sm text-[#EAD584] border border-[#EAD584]/40 rounded-md p-3 bg-[#0F1F4E]/40"
          >
            {error}
          </div>
        )}
        <button
          type="button"
          onClick={handleSignIn}
          data-testid="login-google-btn"
          className="btn-shine inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-sm tracking-wider uppercase text-[#0F1F4E] bg-[#EAD584] hover:bg-[#F0DC8A] transition-colors w-full"
        >
          Continue with Google
        </button>
        <p className="text-xs text-[#D6D6BD]/70 mt-6 font-light">
          You'll be returned here after Google authentication.
        </p>
      </div>
    </main>
  );
}
